import { Component, OnInit, EventEmitter } from '@angular/core';
import { AuthService } from '../auth/auth.service';
import { IUser } from '../users/user';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css']
})
export class NavbarComponent implements OnInit {
  userActions: any = {};
  user: EventEmitter<IUser>;
  userRole = this.auth.getUserRole();
  constructor(
    private auth: AuthService
  ) {
  }

  ngOnInit(): void {
    this.changeUserActions(this.auth.isLoggedIn());
    this.auth.getLoggedIn()
      .subscribe(loggedIn => {
        this.changeUserActions(loggedIn);
      });
  }

  changeUserActions(loggedIn): void {
    if (loggedIn) {
      this.userActions.label = 'Log out';
      this.userActions.url = '/logout';
    } else {
      this.userActions = {};
    }
    this.user = this.auth.getUser();
  }
}



// WEBPACK FOOTER //
// ./src/app/navbar/navbar.component.ts